/* BrandLogo — le logo affiché partout dans l'app.

   Priorité au logo configuré dans l'admin (branding.logoUrl) ; à défaut, le
   logo GoCab Boost livré avec l'app. Il remplace les anciens replis « pastille
   + texte », qui divergeaient d'un écran à l'autre.

   Le fichier par défaut est entièrement en noir pur : toute la forme est portée
   par le canal alpha, y compris le « GO » et le trait séparateur, qui sont des
   réserves transparentes et non des pixels blancs. `invert` le repeint donc en
   blanc sans toucher à l'alpha — on obtient la version réservée exacte, sans
   dérive de teinte possible puisqu'il n'y a aucune couleur à faire tourner.
   Repeindre les pixels en blanc, à l'inverse, boucherait les réserves.

   L'inversion ne vaut QUE pour ce fichier : un logo d'annonceur (`logoUrl`) est
   une image arbitraire et colorée, que l'inverser détruirait.

   Attention, elle est pilotée par le THÈME, pas par la surface : le logo reste
   noir en thème clair. Ne pas le poser sur un aplat sombre en dur (le panneau
   gauche du login, par exemple) — il y serait de nouveau illisible. */
import defaultLogo from "@/assets/logo.png";

export default function BrandLogo({
  logoUrl,
  className = "h-8",
  alt = "GoCab Boost",
  ...rest
}) {
  return (
    <img
      src={logoUrl || defaultLogo}
      alt={alt}
      className={`${className} w-auto object-contain${logoUrl ? "" : " dark:invert"}`}
      draggable={false}
      {...rest}
    />
  );
}
